import { StreamingPlatform as StreamingPlatformType } from 'types';
import { streamingPlatformSelector } from 'store/selectors';
import { useStore } from 'hooks';
import { Switch } from 'components';
import { FacebookCircleLogoIcon, PlusIcon, YoutubeLogoIcon } from 'components/Icon';

import styles from './StreamingPlatform.module.scss';

const PLATFORM = {
  [StreamingPlatformType.FACEBOOK]: {
    title: 'My Facebook page',
    icon: <FacebookCircleLogoIcon />
  },
  [StreamingPlatformType.YOUTUBE]: {
    title: 'My YouTube',
    icon: <YoutubeLogoIcon />
  }
};

export type StreamingPlatformsProps = {
  platform: StreamingPlatformType;
  action: 'add' | 'toggle';
} & (
  | { action: 'add'; onClick?: (platform: StreamingPlatformType) => void }
  | { action: 'toggle'; onChange?: (platform: StreamingPlatformType, enabled: boolean) => void }
);

const StreamingPlatform = (props: StreamingPlatformsProps) => {
  const { action, platform } = props;

  const platformState = useStore(streamingPlatformSelector(platform));

  const handleOnClick = () => {
    if (action === 'add') {
      props.onClick?.(platform);
    }
  };

  const renderAction = () => {
    switch (action) {
      case 'add': {
        return (
          <button type="button" className={styles.add} onClick={handleOnClick}>
            <PlusIcon />
          </button>
        );
      }

      case 'toggle': {
        return (
          <Switch
            checked={platformState.isActive}
            disabled={platformState.stopped}
            onChange={() => props.onChange?.(platform, !platformState.isActive)}
          />
        );
      }

      default:
        return null;
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        {PLATFORM[platform].icon}
        <span>{PLATFORM[platform].title}</span>
      </div>
      {renderAction()}
    </div>
  );
};

export default StreamingPlatform;
